"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconSocialLinkedin = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("b2b-components/core/components/Icon/Icon/SvgWrapper");
const IconSocialLinkedin = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "M19.743 19.748h-3.258v-5.105c0-1.218-.024-2.784-1.697-2.784-1.699 0-1.958 1.324-1.958 2.694v5.195H9.572V9.25h3.13v1.43h.041c.438-.824 1.501-1.695 3.09-1.695 3.3 0 3.911 2.173 3.911 5v5.763ZM5.893 7.814A1.89 1.89 0 0 1 4 5.92a1.892 1.892 0 1 1 1.891 1.893Zm1.633 11.934H4.259V9.25h3.267v10.498ZM21.373 1H2.623C1.726 1 1 1.71 1 2.585v18.83C1 22.291 1.726 23 2.623 23H21.37c.897 0 1.63-.709 1.63-1.585V2.585C23 1.71 22.267 1 21.37 1h.003Z"
}));
exports.IconSocialLinkedin = IconSocialLinkedin;
//# sourceMappingURL=IconSocialLinkedin.js.map